import React, { Component } from 'react'
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@material-ui/core/Modal';
import { Button, Box, Typography, Grid } from '@material-ui/core';
import { withStyles, fade } from "@material-ui/core/styles";
import language from '../../languages';

const styles = (theme) => ({
  title: {
    flexGrow: 1,
    padding: '8px 16px',
    color: 'rgba(2, 2, 2, 0.7)',
    backgroundColor: '#F3F6FF',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionArea: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  saveButton: {
    color: '#ffffff',
    backgroundColor: '#3076CA',
    '&:hover': {
      backgroundColor: fade('#3076CA', 0.75),
    },
    margin: '8px 8px;',
    textTransform: 'capitalize'
  },
  cancelButton: {
    margin: '8px 8px;',
    textTransform: 'capitalize'
  }
});

export class CroppableImage1 extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            src: null,
            crop: {
              unit: '%',
            //   width: 30,
            //   aspect: 16 / 9,
              width: 50,
              height: 50,
            },
            croppedImageUrl: null
        }
    }
    
    
      onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
          const reader = new FileReader();
          reader.addEventListener('load', () =>
            this.setState({ src: reader.result })
          );
          reader.readAsDataURL(e.target.files[0]);
        }
      };
    
      // If you setState the crop in here you should return false.
      onImageLoaded = image => {
        this.imageRef = image;
      };
    
      onCropComplete = crop => {
        this.makeClientCrop(crop);
      };
    
      onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
      };
    
      async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
          const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            crop,
            'newFile.jpeg'
          );
          this.setState({ croppedImageUrl });
        }
      }
    
      getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');
    
        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height
        );
    
        return new Promise((resolve, reject) => {
        //   canvas.toBlob(blob => {
        //     if (!blob) {
        //       //reject(new Error('Canvas is empty'));
        //       console.error('Canvas is empty');
        //       return;
        //     }
        //     blob.name = fileName;
        //     window.URL.revokeObjectURL(this.fileUrl);
        //     this.fileUrl = window.URL.createObjectURL(blob);
        //     resolve(this.fileUrl);
        //   }, 'image/jpeg');
          resolve(canvas.toDataURL())
        });
      }

      onClickSave = () => {
        const { onSave, close } = this.props;
        const {croppedImageUrl} = this.state;
        onSave(croppedImageUrl)
        close() 
      }
    
      render() {
        const { crop, croppedImageUrl, src } = this.state;
        const { classes, lang } = this.props;

        const top = 50 + Math.round(0.5 * 20) - 10;
        const left = 50 + Math.round(0.5 * 20) - 10;

        const modalStyle = {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
            position: 'absolute',
            width: 800,
            height: 500,
            overflow: 'auto',
            backgroundColor: '#ffffff',
            border: '2px solid #000',
            boxShadow: 5,
        }
    
        return (
            <div>
                <Modal
                open={this.props.open}
                onClose={this.props.close}
                aria-labelledby={this.props.labelModal}
                aria-describedby={this.props.labelDes}
                >
                    <div style={modalStyle} >
                      <Box className={classes.title}>
                          <Typography variant="h6" noWrap>
                            {language[lang].Crop_Image}
                          </Typography>
                          <div className={classes.actionArea}>
                            <Button variant="outlined" className={classes.cancelButton} onClick={this.props.close}>{language[lang].Cancel}</Button> 
                            <Button variant='contained' className={classes.saveButton} onClick={this.onClickSave}>{language[lang].Save}</Button>
                          </div>
                      </Box>
                      <Box p={2} >
                        <Grid container direction="row" justify="center" spacing={2}>
                          <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                              {language[lang].Original_Image} :
                            </Typography>
                            {this.props.media && (
                              <ReactCrop
                                  src={this.props.media}
                                  crop={crop}
                                  ruleOfThirds
                                  onImageLoaded={this.onImageLoaded}
                                  onComplete={this.onCropComplete}
                                  onChange={this.onCropChange}
                                  circularCrop={this.props.isAvatar}
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                              {language[lang].Preview_Image} :
                            </Typography>
                            {croppedImageUrl && (
                              <img alt="Crop" style={this.props.isAvatar ? { maxWidth: '100%', borderRadius: '50%' } : {maxWidth: '100%'}} src={croppedImageUrl} />
                            )}
                          </Grid>
                        </Grid>
                        
                        
                      </Box>
                    </div>
                </Modal>
            </div>
        );
      }
}

export default withStyles(styles)(CroppableImage1)